import React from "react"

export default function EmptyState({ icon, title, message, children }) {
  return <div className="text-center py-5 px-3">
    <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light text-secondary mb-3" style={{width:"72px",height:"72px",fontSize:"1.75rem"}}>
      <i className={`fas ${icon}`}></i>
    </div>
    <p className="lead mb-1">{title}</p>
    <p className="text-muted mb-3">{message}</p>
    {children}
  </div>
}
